/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import UserProfileController from '../../../../common/components/UserProfileController';
import ReporterType from '../../../../infra/aggregates/reportsToInterface';
import CustomDashboardCard from '../../../../common/components/CustomDashboardCard/CustomDashboardCard';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import { Box, Typography } from '@mui/material';
import { fonts, themes } from '../../../../common/themes/themes';
import EmployeeTeam from '../../../../common/components/EmployeesTeam/EmployeeTeam';

interface eventList {
  reporter: ReporterType;
  isLoading?: boolean;
  teamMembers: any;
  i18n: any;
  trans: any;
}

const ReporterPresenter = ({
  reporter,
  isLoading,
  teamMembers,
  trans,
}: eventList) => {
  return (
    <>
      <CustomDashboardCard cardSize={{ card_title: trans('Reports To') }}>
        {isLoading ? (
          <div style={{ marginLeft: '-2em' }}>
            <Loader height={100} width={200} />
          </div>
        ) : reporter?.emp_name == '' ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={emptyIcon} />
            <Typography
              style={{
                fontFamily: fonts.fontFamily,
                color: themes.greyDefault_500,
                fontSize: fonts.title,
              }}
            >
              {trans('Not assign any reporter!')}
            </Typography>
          </div>
        ) : (
          <div
            style={{
              marginTop: '-30px',
            }}
          >
            <UserProfileController reporter={reporter} />
          </div>
        )}{' '}
        <div>
          <Typography
            style={{
              color: themes.blackDefault,
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
          >
            {`${trans('My Team')} (${Object.keys(teamMembers).length})`}
          </Typography>
          <Box>
            <EmployeeTeam teamMembers={teamMembers} />
          </Box>
        </div>
      </CustomDashboardCard>
    </>
  );
};

export default ReporterPresenter;
